export interface UserProfileData {
  uuid?: string;
  email?: string;
  username?: string;
  role?: string;
  ageGroup?: string;
  ageGroupOther?: string;
  ethnicGroups?: string[];
  ethnicGroupOther?: string;
  howDidYouFindOut?: string;
  howDidYouFindOutOther?: string;
  gender?: string;
  password?: string;
  confirm_password?: string;
  emailAllow?: boolean;
  contactPermission?: boolean;
  userAgent?: string;
  registrationSource?: string;
  habitsId?: string;
  country?: string;
  mobile?: string;
  smsAllow?: boolean;
  location?: string;
  createdAt?: number;
  updatedAt?: number;
  accessedAt?: number;
}

export const whoAreYouGroupOptions = [
  { label: "Young person 13-15", value: "youngperson13to15" },
  { label: "Young person 16-19", value: "youngperson16to19" },
  { label: "Other", value: "other" }
];

export const ethnicGroupOptions = [
  { "label": "NZ European", "value": "nzeuropean" },
  { "label": "Māori", "value": "maori" },
  { "label": "Pacific", "value": "pacific" },
  { "label": "Asian", "value": "asian" },
  { "label": "Prefer not to answer", "value": "prefernottoanswer" },
  { "label": "Other", "value": "other" }
];

export const genderGroupOptions = [
  { "label": "Male", "value": "male" },
  { "label": "Female", "value": "female" },
  { "label": "Transgender", "value": "transgender" },
  { "label": "Intersex", "value": "intersex" },
  { "label": "Not specified", "value": "undisclosed" },
  { "label": "Prefer not to answer", "value": "prefernottoanswer" }
];

export const howDidYouFindOutOptions = [
  { "label": "Advertisement", "value": "advertisement" },
  { "label": "Counsellor", "value": "counsellor" },
  { "label": "Doctor/nurse", "value": "doctor_nurse" },
  { "label": "Facebook", "value": "facebook" },
  { "label": "Friend", "value": "friend" },
  { "label": "Google/google search", "value": "google" },
  { "label": "Google ads", "value": "google_ads" },
  { "label": "Media", "value": "media" },
  { "label": "School", "value": "school" },
  { "label": "St John School visit", "value": "st_john_school_visit" },
  { "label": "Youth worker", "value": "youth_worker" },
  { "label": "Other", "value": "other" }
];

export const deleteAccountReasonOptions = [
  { "label": "I completed SPARX", "value": "completed" },
  { "label": "I am no longer interested", "value": "not_interested" },
  { "label": "I had trouble using SPARX", "value": "trouble" },
  { "label": "I have a suggestion", "value": "suggestion" },
  { "label": "Other", "value": "other" },
];
